var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_2615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9978 25.9958C20.1763 25.9958 25.9956 20.1765 25.9956 12.998C25.9956 5.8195 20.1763 0.000183105 12.9978 0.000183105C5.81932 0.000183105 0 5.8195 0 12.998C0 20.1765 5.81932 25.9958 12.9978 25.9958Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9985 5.08618L13.4193 6.38134H14.781L13.6793 7.18178L14.1002 8.47694L12.9985 7.67645L11.8967 8.47694L12.3175 7.18178L11.2158 6.38134H12.5776L12.9985 5.08618Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40416 7.40342L8.61763 8.02163L9.58054 7.05878L9.36744 8.40375L10.5809 9.02201L9.23584 9.23505L9.0228 10.5801L8.40454 9.3667L7.05957 9.5798L8.02248 8.61689L7.40416 7.40342Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08691 12.9979L6.38208 12.577V11.2153L7.18246 12.317L8.47767 11.8962L7.67714 12.9979L8.47767 14.0996L7.18246 13.6788L6.38208 14.7805V13.4188L5.08691 12.9979Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40416 18.5923L8.02242 17.3788L7.05957 16.4159L8.40459 16.6291L9.02275 15.4156L9.23584 16.7607L10.5808 16.9737L9.36755 17.592L9.58054 18.9369L8.61763 17.974L7.40416 18.5923Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9985 20.9096L12.5775 19.6144H11.2158L12.3176 18.814L11.8967 17.5189L12.9985 18.3193L14.1002 17.5189L13.6793 18.814L14.781 19.6144H13.4193L12.9985 20.9096Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5936 18.5923L17.3802 17.9741L16.4172 18.937L16.6303 17.5919L15.417 16.9737L16.762 16.7607L16.975 15.4156L17.5932 16.6291L18.9382 16.4159L17.9753 17.3789L18.5936 18.5923Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9102 12.9979L19.615 13.4188V14.7805L18.8146 13.6788L17.5195 14.0996L18.32 12.9979L17.5195 11.8962L18.8146 12.317L19.615 11.2153V12.5771L20.9102 12.9979Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5936 7.40337L17.9753 8.61684L18.9382 9.57975L17.5932 9.3666L16.975 10.58L16.762 9.235L15.417 9.02191L16.6303 8.4037L16.4172 7.05878L17.3802 8.02163L18.5936 7.40337Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_2615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9956,
    height: 25.9956,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/eu.95f4b6f68c012488f708566c44cde6de.svg";
export { ForwardRef as ReactComponent };